var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Form } from 'react-bootstrap';
export const CheckboxInput = forwardRef((_a, ref) => {
    var { label, type } = _a, rest = __rest(_a, ["label", "type"]);
    return (_jsx("div", Object.assign({ className: 'checkbox-input' }, { children: _jsx(Form.Check, Object.assign({}, rest, { id: rest.name, ref: ref, type: 'checkbox', label: label, checked: rest.value, value: rest.value || '' })) })));
});
CheckboxInput.displayName = 'CheckboxInput';
